<template>
  <div class="container">
    <table class="table table-borderless">
      <tbody class="body">
        <tr>
          <td class="col-6 head">Transfer Batch No.</td>
          <td class="col-6 head">Content Type</td>
        </tr>
        <tr>
          <td class="content">
            {{ contentStore.currentContent.name }}
          </td>
          <td class="content">{{ contentStore.currentContent.contentType }}</td>
        </tr>
        <tr>
          <td class="head">Date Received</td>
          <td class="head">Package Type</td>
        </tr>
        <tr>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                contentStore.currentPackageForReingest.createdAt
              )
            }}
          </td>
          <td class="content">
            {{ contentStore.currentPackageForReingest.packageType }}
          </td>
        </tr>
        <tr>
          <td class="head">UUID</td>
          <td></td>
        </tr>
        <tr>
          <td class="content">
            {{ contentStore.currentPackageForReingest.packageId }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="head">Status</td>
          <td class="head">Version</td>
        </tr>
        <tr>
          <td class="content">
            {{ contentStore.currentPackageForReingest.status }}
          </td>
          <td class="content">
            {{ contentStore.currentPackageForReingest.packageVersion }}
          </td>
        </tr>
        <tr>
          <td class="head">Highest Security Grading</td>
          <td class="head">Highest Sensitivity Classification</td>
        </tr>
        <tr>
          <td class="content">
            {{ contentStore.currentPackageForReingest.highestSecurityGrading }}
          </td>
          <td class="content">
            {{
              contentStore.currentPackageForReingest
                .highestSensitivityClassification
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { useContentStore } from "@/stores/content_review/content";
import { useAsyncState } from "@vueuse/core";
import { watch } from "vue";

const contentStore = useContentStore();

watch(
  () => props.transferId,
  () => execute()
);

const props = defineProps({
  transferId: { type: String, required: true },
});

const { execute, error } = useAsyncState(() => {
  return contentStore.fetchPackageForReingest(props.transferId);
}, null);
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 16px;
  min-width: 100%;
  overflow: auto;
}
</style>
